import axios from "axios";
import { SETTINGS } from "../../Settings";

export const SigningKeystoreRepository = {
  uploadKeystore: (request) => {
    return axios({
      url: `${SETTINGS.INTERNAL_API_URL}internal/signingKeystores/upload-keystore`,
      method: "POST",
      data: request,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
  fetchUserKeystore: () => {
    return axios({
      url: `${SETTINGS.INTERNAL_API_URL}internal/signingKeystores/user-keystore`,
      method: "GET",
    });
  },
  downloadKeystore: () => {
    return axios({
      url: `${SETTINGS.INTERNAL_API_URL}internal/signingKeystores/download-keystore`,
      method: "GET",
      responseType: "blob",
    });
  },
};
